import TableTemplate, {
  IFilterTableCols,
} from "../../TableTemplate/tableTemplate";
import {
  IOptionDomainLiveWatchListSearchParam,
  IOptionDomainSearchParams,
} from "../../../Interfaces/optionDomain";
import { CommonTableUI } from "../../TableTemplate/common";
import { getBaseInsCalculationsTable } from "../../../Requests/optionDomain";

interface IProps {
  filterCols: IFilterTableCols;
  searchParams: IOptionDomainSearchParams;
  refreshFlag: boolean;
}

const BaseInsCalculationsTable = ({
  filterCols,
  searchParams,
  refreshFlag,
}: IProps) => {
  return (
    <TableTemplate<IOptionDomainLiveWatchListSearchParam, any>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          filterCols={filterCols}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[600px] !max-w-full overflow-x-auto"
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getBaseInsCalculationsTable}
      searchParameters={searchParams}
      withSort
    />
  );
};

export default BaseInsCalculationsTable;
